// extracted by mini-css-extract-plugin
module.exports = {"Title":"videos_Title__syal1","Item":"videos_Item__CLsOn","Videos":"videos_Videos__FC18B"};